import { render, staticRenderFns } from "./UserHeaderComponent.vue?vue&type=template&id=f61984de&scoped=true&"
import script from "./UserHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./UserHeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserHeaderComponent.vue?vue&type=style&index=0&id=f61984de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61984de",
  null
  
)

export default component.exports